<template>
  <div class="social-links-container">
    <ul class="social-links">
      <li>
        <a
          href="https://vk.com/demis.group"
          target="_blank"
        >
          <i class="fa fa-vk fa-2x" />
          <span>ВКонтакте</span>
        </a>
      </li>
      <li>
        <a
          href="https://t.me/demisgroup"
          target="_blank"
        >
          <i class="fa fa-telegram fa-2x" />
          <span>Telegram</span>
        </a>
      </li>
    </ul>
    <ul class="social-links">
      <li>
        <a
          href="https://t.me/mmconf2022"
          target="_blank"
        >
          <i class="fa fa-telegram fa-2x" />
          <span>Нейроконференции</span>
        </a>
      </li>
      <li>
        <a
          href="https://youtube.com/@DemisRu"
          target="_blank"
        >
          <i class="fa fa-youtube-play fa-2x" />
          <span>YouTube</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TheSocialLinks'
}
</script>

<style lang="scss" scoped>
@import './resources/css/_variables.scss';

.social-links-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.social-links {
  display: flex;
  justify-content: space-between;
  margin: 0 0 10px 0;
  list-style: none;
  padding: 0;
  width: auto;
  min-width: 300px;
  & > li {
    margin: 0 auto;
    a {
      display: flex;
      align-items: center;
      color: #282828;
      text-decoration: none;
      &:hover {
        .fa-vk {
          color: #4c75a3;
        }
        .fa-telegram {
          color: #2aabee;
        }
        .fa-youtube-play {
          color: #f00;
        }
      }
      & > span {
        display: inline-block;
        padding-left: 5px;
        text-align: left;
        white-space: nowrap;
      }
    }
  }
}
</style>
